import { Experiment } from '@/lib/amplitude/create-amplitude-paths'

export const getExperimentsWithProvider = (experiments: Experiment[]) => {
	return experiments
		.filter((experiment) => {
			// @ts-ignore
			return experiment.variants[0]?.payload?.isExperimentProvider || false
		})
		.map((experiment) => {
			return {
				value: experiment.key,
				label: experiment.name
			}
		})
}
